/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconVOMP = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconVOMP"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="m19.182 16.22 1.64 1.145c-2.016 2.885-5.275 4.637-8.825 4.637-3.433 0-6.597-1.64-8.624-4.36l-.192-.266 1.638-1.148c1.647 2.352 4.296 3.774 7.178 3.774 2.787 0 5.355-1.329 7.01-3.542zM19.178 13.504c-1.645-2.37-4.304-3.804-7.2-3.804-2.754 0-5.296 1.298-6.955 3.467l-.18.245-1.629-1.161C5.235 9.415 8.465 7.7 11.978 7.7c3.45 0 6.626 1.655 8.65 4.395l.193.269z"
    />
    <path
      fill="currentColor"
      d="M11.997 12a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2M13 3v3h-2V3zM20.232 5l-1.5 2.598-1.732-1L18.5 4zM4 5l1.5 2.598 1.732-1L5.732 4z"
    />
  </svg>
);
export default IconVOMP;
